import { collection, deleteDoc, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { getFirestoreDb } from '@/lib/firebase';

export async function removeOrgMember(
  orgId: string,
  actorUid: string,
  targetUid: string
): Promise<{ ok: true }> {
  if (targetUid === actorUid) throw new Error('Cannot remove yourself');

  const memberRef = doc(getFirestoreDb(), 'organizations', orgId, 'members', targetUid);
  const snap = await getDoc(memberRef);
  if (!snap.exists()) throw new Error('Member not found');
  if (snap.data()?.role === 'owner') {
    const owners = await getDocs(
      query(
        collection(getFirestoreDb(), 'organizations', orgId, 'members'),
        where('role', '==', 'owner')
      )
    );
    if (owners.size <= 1) throw new Error('Cannot remove the last owner');
  }

  await deleteDoc(memberRef);
  return { ok: true };
}
